import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import FeatureGrid from "./components/FeatureGrid";
import Testimonial from "./components/Testimonial";
import CTASection from "./components/CTASection";
import SEOArticlesSection from "./components/SEOArticlesSection";
import Footer from "./components/Footer";
import { WebsiteJsonLd } from "@/components/base/SEOJsonLd";

export default function Home() {
  return (
    <>
      <WebsiteJsonLd pageUrl="/" />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <AboutSection />
        <FeatureGrid />
        <Testimonial />
        <CTASection />
        <SEOArticlesSection />
      </main>
      <Footer />
    </>
  );
}